import React, {FC} from 'react';
import dayjs from 'dayjs';
import styles from './styles/index.module.scss'

interface IContactWave {
    userInfo: Record<any, any>;
}
const ContactWave:FC<IContactWave> = ({userInfo}) => {
    return (
        <div className={styles['wrapper']}>
            <section>
                <span>Заявка {userInfo.orders.join(',')}</span>
                <div className={styles['title']}><i>Искусственная волна</i></div>
                <h1 className={styles['sub-title']}>Анкета-соглашение</h1>
                <br/>
                    <p>
                        Настоящее соглашение заключается между <b>Обществом с ограниченной ответственностью ООО
                        «СЁРФСТЕЙШН»</b>,
                        именуемое в дальнейшем &quot;Исполнитель&quot; и любым лицом, подающим заявку, в дальнейшем именуемым
                        &quot;Заказчик&quot;, вместе
                        по тексту Соглашения именуемые &quot;Стороны&quot;, а в отдельности – &quot;Сторона&quot;.
                    </p>
                    <br/>
                        <p>
                            Исполнитель обязуется оказывать комплекс услуг Заказчику, клиентам Заказчика (далее – Клиентам)
                            по использованию
                            искусственной волны для сёрфинга (далее - &quot;сёрфинг-тренажер&quot;), и(или) аэродинамической трубы,
                            вместе по тексту
                            Соглашения именуемые &quot;Тренажеры&quot;, на определенных настоящим Соглашением условиях, а Заказчик
                            обязуется
                            оплачивать эти услуги, соблюдать правила посещения тренажеров и соглашается с их условиями.
                        </p>
                        <br/>
                            <b>Правила посещения и безопасности Центра и ООО «СЁРФСТЕЙШН»:</b>
                            <ul>
                                <li>
                                    На тренажеры допускаются дети при обязательном сопровождении взрослых старше 18 лет,
                                    которые несут полную
                                    ответственность за детей;
                                </li>
                                <li>
                                    на искусственную волну для сёрфинга допускаются дети с 8 до 14 лет только в
                                    сопровождении взрослых
                                    (родителей/доверенных лиц) и в сопровождении отдельного инструктора ООО «СЁРФСТЕЙШН»;
                                </li>
                                <li>
                                    на искусственную волну для сёрфинга допускаются дети с 14 до 18 лет только в
                                    сопровождении взрослых
                                    (родителей/доверенных лиц);
                                </li>
                                <li>
                                    на искусственную волну для сёрфинга допускаются только дети и взрослые умеющие плавать,
                                    умеющие задерживать
                                    дыхание минимум на 20 секунд;
                                </li>
                                <li>
                                    к полетам в аэродинамической трубе допускаются дети от 4 лет только в сопровождении
                                    взрослых
                                    (родителей/доверенных лиц) и в сопровождении отдельного инструктора Центра;
                                </li>
                                <li>
                                    В случаях, если дети нарушают установленные правила и игнорируют вышеперечисленные
                                    ограничения, сопровождающие
                                    их взрослые, несут полную ответственность за них;
                                </li>
                                <li>
                                    Не допускается нахождение людей в состоянии алкогольного, наркотического, токсического
                                    опьянения, а также
                                    находящихся под воздействием медицинских препаратов, которые понижают скорость реакции и
                                    искажают восприятие;
                                </li>
                                <li>
                                    Вход на сёрфинг-тренажер разрешен исключительно босиком;
                                </li>
                                <li>
                                    На тренажеры не допускаются люди, вес которых превышает 120 кг;
                                </li>
                                <li>
                                    Перед использование тренажера необходимо снять все ювелирные украшения и вынуть из
                                    карманов все предметы во
                                    избежание их утери;
                                </li>
                                <li>
                                    На все тренажеры запрещено проносить посторонние вещи (телефоны, фотоаппараты и пр.);
                                </li>
                                <li>
                                    В связи с тем, что эксплуатация тренажеров ООО «СЁРФСТЕЙШН», сопряжена с риском
                                    (возможно получение травм),
                                    настоятельно <b>рекомендуется использование защитного шлема</b>;
                                </li>
                                <li>
                                    В связи с тем, что эксплуатация тренажеров Центра (аэродинамическая труба), сопряжена с
                                    риском (возможно
                                    получение травм), <b>обязательно использование защитного шлема</b>;
                                </li>
                                <li>
                                    Во время использования тренажера необходимо выполнять все указания инструктора;
                                </li>
                                <li>
                                    В целях обеспечения общественной безопасности и предотвращения террористических актов
                                    посетители обязаны по
                                    требованию предъявить персоналу Центра содержимое личных вещей для проверки;
                                </li>
                                <li>
                                    При эксплуатации тренажеров обязательно присутствие инструктора;
                                </li>
                                <li>
                                    Посетители должны выполнять любые просьбы или требования
                                    администраторов/операторов/инструкторов
                                    спортивно-развлекательного Центра в отношении обеспечения безопасности, поддержания
                                    порядка и чистоты на
                                    территории Центра;
                                </li>
                                <li>
                                    Посетители пользуются тренажерами ООО «СЁРФСТЕЙШН», под свою ответственность и на свой
                                    страх и риск.
                                </li>
                            </ul>
                            <br/>
                                <b><u>Запрещается:</u></b>
                                <p>
                                    - Запрещается пользоваться всеми тренажерами Центра (сёрфинг-тренажер, аэродинамическая
                                    труба) посетителям: с
                                    сердечно-сосудистыми и психоневрологическими заболеваниями, привычным вывихом, вывихов
                                    рук, ног или плечевого
                                    сустава, с заболеваниями позвоночника и опорно-двигательного аппарата, при наличии
                                    незаживших ран, а также
                                    беременным женщинам.
                                    <br/>
                                        - Запрещается нырять в воду с бортиков, удерживать друг друга под водой,
                                        использовать не одобренное
                                        администрацией Центра оборудование и инвентарь.
                                        <br/>
                                            - Во избежание падений и травм запрещается быстрая ходьба и бег на территории
                                            Центра.
                                            <br/>
                                                - Запрещается находиться на сёрфинг-тренажере в верхней одежде, купальных
                                                костюмах с поясами, заклепками,
                                                пряжками и другими металлическими украшениями.
                                                <br/>
                                                    - Запрещается использовать сёрфинг-тренажер лицам с открытыми ранами,
                                                    инфекционными, кожными и другими видами
                                                    заболеваний, а также при наличии медицинских повязок и лейкопластырей.
                                                    Посетители, нарушившие данное правило,
                                                    несут полную ответственность за ущерб, причиненный здоровью других
                                                    Посетителей, и сопутствующие материальные
                                                    расходы.
                                                    <br/>
                                                        - Запрещается курение на всей территории спортивно-развлекательного
                                                        Центра.
                                                        <br/>
                                                            - Запрещается проносить на территорию Центра огнестрельное,
                                                            газовое, пневматическое и холодное оружие,
                                                            колюще-режущие предметы, а также взрывчатые и
                                                            легковоспламеняющиеся, токсичные и сильно пахнущие предметы.
                                                            <br/>
                                                                - Запрещается входить в любые технические и служебные
                                                                помещения Центра и самостоятельно регулировать любое
                                                                инженерно-техническое оборудование. Посетители, проникшие в
                                                                такие помещения, несут полную ответственность за
                                                                неполадки и аварии, произошедшие в этой зоне.
                                </p>
                                <br/>
                                    <b><u>Порча имущества.</u></b>
                                    <p>
                                        В случае обнаружения порчи оборудования тренажеров, посетители обязаны сразу
                                        сообщить об этом инструктору
                                        Центра. Представители спортивно-развлекательного Центра должны составить
                                        соответствующий акт. В случае утраты и
                                        повреждения имущества спортивно-развлекательного Центра по вине посетителя, он
                                        обязан возместить причиненный
                                        ущерб, а также понести ответственность за иные допущенные им нарушения в
                                        соответствии с действующим
                                        законодательством РФ.
                                    </p>
                                    <p>
                                        Несоблюдение вышеуказанных правил или попытка помешать отдыху других посетителей,
                                        является основанием для удаления
                                        посетителя с территории спортивно-развлекательного Центра без какого-либо денежного
                                        возмещения.
                                    </p>
                                    <br/>
                                        <b><u>Ответственность Сторон.</u></b>
                                        <p>
                                            <u>Ответственность Исполнителя:</u>
                                            Исполнитель принимает на себя ответственность за качественное оказание услуг по
                                            предварительной и подтвержденной
                                            заявке Заказчика.
                                            Исполнитель не несет ответственность в случаях:
                                            <br/>
                                                - Несоблюдения Заказчиком и/или сопровождающими его лицами требований
                                                безопасности;
                                                <br/>
                                                    - Совершение Заказчиком и/или сопровождающими его лицами противоправных
                                                    действий или бездействий, в результате
                                                    которых создалась невозможность выполнения Исполнителем своих
                                                    обязательств;
                                                    <br/>
                                                        - Оставления без надлежащего надзора детей;
                                                        <br/>
                                                            - Оставления без надлежащего присмотра личных вещей Заказчика во
                                                            всех помещениях спортивно-развлекательного
                                                            Центра, включая помещения, переданные в аренду третьим лицам;
                                                            <br/>
                                                                - Изменения в расписании спортивно-развлекательного Центра,
                                                                по независящим от Исполнителя причинам;
                                        </p>
                                        <p>
                                            <u>Ответственность Заказчика:</u>
                                            Заказчик несет ответственность в соответствии с настоящим Соглашением за
                                            правильность и достоверность
                                            предоставленной Исполнителю информации.
                                            В случае причинения Заказчиком и/или лицами, с ним следующими/его
                                            сопровождающими, имущественного ущерба
                                            Исполнителю, данный ущерб должен быть возмещен Заказчиком в полном объёме.
                                            Заказчик признает, что он, его ребенок/подопечный добровольно принимает участие
                                            по использованию тренажеров
                                            компании Центра и ООО «СЁРФСТЕЙШН», осознает и принимает риск возможных травм,
                                            которые могут стать результатом
                                            несоблюдения техники безопасности. Заказчик полностью берет на себя возможный
                                            риск причинения вреда здоровью,
                                            включая травму, которая может стать результатом несоблюдения любых установленных
                                            в Центре и ООО «СЁРФСТЕЙШН»
                                            правил и инструкций, а также какой-либо ущерб, включая потерю личного имущества.
                                            Заказчик также понимает и предупрежден, что тренажеры компании ООО «СЁРФСТЕЙШН»
                                            противопоказаны при:
                                            беременности, серьезных заболеваниях спины или позвоночника, остеопорозе
                                            (недостаток в организме кальция и
                                            хрупкость костей), серьезных болезнях сердца, психических расстройствах,
                                            эпилепсии, а также при наличии
                                            незаживших ран, вывихов рук, ног или плечевого сустава.
                                        </p>
                                        <p>
                                            В случае невыполнения или ненадлежащего выполнения своих обязательств по
                                            Соглашению Стороны несут
                                            ответственность в соответствии с условиями настоящего Соглашения и
                                            законодательством Российской Федерации.
                                        </p>
                                        <p>
                                            <b><u>Персональные данные.</u></b>
                                            По настоящему Соглашению, Заказчик при указании персональных данных на основании
                                            ст. 9 Федерального закон от 27
                                            июля 2006 г. N 152-ФЗ &quot;О персональных данных&quot; дает свое согласие:
                                            <br/>
                                                - На обработку предоставленных персональных данных Исполнителем;
                                                <br/>
                                                    - На иные действия Исполнителя в отношении предоставленных персональных
                                                    данных в соответствии с требованиями
                                                    вышеуказанного Федерального закона.
                                                    <br/>
                                                        - Указывая свои персональные данные, Заказчик подтверждает, что
                                                        делает это добровольно, а также, что он
                                                        добровольно предоставляет их Исполнителю для обработки.
                                        </p>
                                        <p>
                                            <b>
                                                Подписанием настоящей Анкеты и соглашения я в полном объеме соглашаюсь с
                                                условиям посещения Центра и ООО
                                                «СЁРФСТЕЙШН», изложенным в Правилах посещения и безопасности Центра и ООО
                                                «СЁРФСТЕЙШН», в том числе, с
                                                условиями оказания услуг, включая их вид, объем и стоимость моего участия
                                                (участия моего ребенка/подопечного)
                                                в использовании тренажеров Центра и ООО «СЁРФСТЕЙШН».
                                            </b>
                                        </p>
                                        <br/>
                                            <b>С условиями соглашения ознакомлен, согласен, обязуюсь выполнять.</b>
                                            <br/>
                                                <table className={styles['personal-data']}>
                                                    <tbody>
                                                    <tr>
                                                        <td>
                                                            <div>
                                                                <span>ФИО:</span>
                                                                <div className={styles['personal-data__block']}>
                                                                    <span  className={styles['personal-data__underline']}>{`${userInfo.last_name} ${userInfo.first_name} ${userInfo.patronymic_name}`}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <span>Телефон:</span>
                                                                <div className={styles['personal-data__block']}>
                                                                    <span  className={styles['personal-data__underline']}>{userInfo.phone}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <div>
                                                                <span>Дата:</span>
                                                                <div className={styles['personal-data__block']}>
                                                                    <span  className={styles['personal-data__underline']}>{dayjs().format('DD.MM.YYYY')}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <span>Подпись:</span>
                                                                <div className={styles['personal-data__block']}>
                                                                    <span  className={styles['personal-data__underline']}/>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className={styles['personal-data__wide']} colSpan={2}>
                                                            <div>
                                                                <span>Email:</span>
                                                                <div className={styles['personal-data__block']}>
                                                                    <span  className={styles['personal-data__underline']}>{userInfo.email}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                                <br/>
                                                    <b><u>Заполняется если участник младше 18 лет и в сопровождении
                                                        родителей:</u></b>
                                                    <p>
                                                        Я прочитал(а) все вышесказанное, у меня была возможность задать
                                                        вопросы, осознать последствия, понять
                                                        содержание, и согласиться в своих интересах, моего ребенка или
                                                        подопечного со всем вышесказанным.
                                                    </p>
                                                    <br/>
                                                        <div>
                                                            ___________________________/______________________
                                                        </div>
                                                        <div>
                                                            Дата: <span className={styles['underline']}/>
                                                        </div>
                                                        <div>Подпись родителя/фактического опекуна</div>
                                                        <br/>
                                                            <div>__________________________________________________________________________________________</div>
                                                            <div>Имя ребенка-участника, возраст</div>
                                                            <br/>
                                                                <div>
                                                                    ___________________________/______________________
                                                                </div>
                                                                <div>
                                                                    Подпись, фамилия сотрудника
                                                                </div>
            </section>
        </div>
    );
};

export default ContactWave;